import { Routes, Route } from 'react-router-dom';
import Home from './Components/Core/Home';
import Nav from './Components/Core/Nav';
import Swiftle from './Components/Projects/Swiftle'
import BookIt from './Components/Projects/BookIt/BookIt';
import MyBooknook from './Components/Projects/MyBooknook/MyBooknook';
import HarvardX from './Components/Projects/HarvardX/HarvardX';
import TopNav from './Components/Core/TopNav';
import Episode from './Components/Projects/Episode/Episode';
import SpotifyMe from './Components/Projects/SpotifyMe';
import SnapCart from './Components/Projects/SnapCart/SnapCart';
import Popdle from './Components/Projects/Popdle/Popdle';

function App() {

  return (
    <div>
      <div id="defNav">
        <Nav/>
      </div>
      <div id="topNav">
        <TopNav/>
      </div>
      <Routes>
        <Route exact path='/' element={<Home/>}></Route>
        <Route exact path='/spotify-me' element={<SpotifyMe/>}></Route>
        <Route exact path='/swiftle-wordle' element={<Swiftle/>}></Route>
        <Route exact path='/book-it' element={<BookIt/>}></Route>
        <Route exact path='/my-booknook' element={<MyBooknook/>}></Route>
        <Route exact path='/harvardX' element={<HarvardX/>}></Route>
        <Route exact path='/episode' element={<Episode/>}></Route>
        <Route exact path='/snapcart' element={<SnapCart/>}></Route>
        <Route exact path='/popdle' element={<Popdle/>}></Route>
      </Routes>
    </div>
  );
}

export default App;
